import TransactionsList from '../transactions/TransactionsList';
import { convertPaymentsToTransactions } from '../../helpers/payments';
import { PaymentsGroup } from '../../types/payments';

export default function CheckoutTransactionsSection({
  paymentsGroup,
}: {
  paymentsGroup: PaymentsGroup;
}) {
  const sortedTransactions = convertPaymentsToTransactions(
    paymentsGroup?.payments ?? [],
    { paymentsGroup },
  );

  return <TransactionsList transactions={sortedTransactions} />;
}
